import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { UserApi } from 'services/user';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Modal from 'sub_components/Common/PortalModalNew';
import BloxButton from 'sub_components/Common/BloxButton';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const closeButton = `${CDN_URL}common/modal-x-button-default-lg.svg`;
const closeHover = `${CDN_URL}common/modal-X-button-hover.svg`;

const defaultUploadCloud = `${CDN_URL}common/upload-icon-default.svg`;
const hoverUploadCloud = `${CDN_URL}common/upload-icon-hover.svg`;

class ImageCrop extends Component {
	constructor(props) {
		super(props);

		this.state = {
			originalImage: null,
			croppedImage: null,
			cropBlob: null,
			fileName: '',
			error: '',
			crop: {
				unit: 'px',
				width: 178,
				height: 178,
				aspect: 16,
			},
		};
	}

	onSelectFile = files => {
		const response = new Promise(resolve => {
			files.forEach((file, index) => {
				const reader = new FileReader();
				reader.onload = () => {
					const arrayBufferView = new Uint8Array(reader.result);
					const blob = new Blob([arrayBufferView], { type: 'image/jpeg' });

					const imageUrl = URL.createObjectURL(blob);

					this.setState({ originalImage: imageUrl, croppedImage: null });
					if (files.length - 1 === index) {
						resolve();
					}
				};

				reader.onabort = () => console.log('file reading was aborted');
				reader.onerror = () => console.log('file reading has failed');

				reader.readAsArrayBuffer(file);
			});
		});
		response.then(() => {});
	};
	onImageLoaded = image => {
		this.imageRef = image;
	};

	onComplete = crop => {
		this.createSelectedCrop(crop);
	};

	onChange = crop => {
		this.setState({ crop });
	};

	async createSelectedCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImage = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg');

			this.setState({ croppedImage });
		}
	}

	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement('canvas');
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = crop.width;
		canvas.height = crop.height;
		const ctx = canvas.getContext('2d');

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width,
			crop.height,
		);
		return new Promise(resolve => {
			canvas.toBlob(blob => {
				if (!blob) {
					//reject(new Error('Canvas is empty'));
					console.error('Canvas is empty');
					return;
				}
				// eslint-disable-next-line
				blob.name = fileName;

				this.setState({ cropBlob: blob, fileSize: blob.size });

				window.URL.revokeObjectURL(this.fileUrl);
				this.fileUrl = window.URL.createObjectURL(blob);
				resolve(this.fileUrl);
			}, 'image/jpeg');
		});
	}

	closeModal = () => {
		const { fileSize } = this.state;
		const { setModalContent } = this.props;

		if (fileSize < 2000000) {
			this.sendImage();
		} else {
			const button = (
				<BloxButton
					className='buttons41'
					id='okay'
					text='OKAY'
					module='profile'
					enabled={true}
					onClick={() => {}}
					cypressId='okay'
				/>
			);

			setModalContent(
				'TIMEOUT_CLOSE',
				'File size too large please reduce your image size and try again.',
				button,
			);
		}
		this.setState({ originalImage: null });
	};

	sendImage = () => {
		const { cropBlob, croppedImage } = this.state;
		const { callback } = this.props;

		UserApi.saveUserProfileImageRequest(cropBlob)
			.then(response => {
				if (response.status === 200 && !response.data.error) {
					callback(croppedImage);
					this.setState({ error: null });
				} else {
					this.setState({ error: 'Error: Could not save your image.' });
				}
			})
			.catch(() => this.setState({ error: 'Error: Could not save your image.' }));
	};
	renderBrowseButton = () => {
		return (
			<Dropzone onDrop={acceptedFiles => this.onSelectFile(acceptedFiles)}>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps()}>
						<input {...getInputProps()} data-cy='upload-input' />
						<div
							data-cy='upload-button'
							className='upload-image-button'
							onClick={() => {
								this.setState({ open: true });
							}}
						>
							<div alt='upload' className='upload-cloud body10'>
								<img
									src={defaultUploadCloud}
									onMouseOver={e => (e.target.src = hoverUploadCloud)}
									onMouseOut={e => (e.target.src = defaultUploadCloud)}
								/>
							</div>
						</div>
					</div>
				)}
			</Dropzone>
		);
	};
	deleteImage = () => {
		const { handleAvatarDelete } = this.props;
		UserApi.deleteUserProfileImageRequest()
			.then(response => {
				if (response.status === 200 && !response.data.error) {
					handleAvatarDelete();
					this.setState({ error: null });
				} else {
					this.setState({ error: 'Error: Could not delete your image.' });
				}
			})
			.catch(() => this.setState({ error: 'Error deleting your image.' }));
	};

	render() {
		const { auth_status } = this.props;
		const {
			user: {
				userProfile: { userImage },
			},
		} = auth_status;
		const { originalImage, crop, error } = this.state;
		return (
			<div className='image-crop-container'>
				<div className='crop-input-wrapper'>
					{this.renderBrowseButton()}
					{error && <div className='error-text body10'>{error}</div>}
					{userImage && (
						<div className='image-delete-button' onClick={this.deleteImage}>
							<img
								src={closeButton}
								onMouseOver={e => (e.target.src = closeHover)}
								onMouseOut={e => (e.target.src = closeButton)}
								data-cy='delete-button'
							/>
							<div className='title body10'>DELETE</div>
						</div>
					)}
				</div>
				{originalImage && (
					<Modal>
						<div className='react-crop-component-container'>
							<div className='react-crop-wrapper'>
								<div className='title heading60'>Select the area you would like to crop.</div>
								<ReactCrop
									src={originalImage}
									crop={crop}
									ruleOfThirds
									onImageLoaded={this.onImageLoaded}
									onComplete={this.onComplete}
									onChange={this.onChange}
									minWidth={125}
									minHeight={125}
									maxWidth={800}
									maxHeight={800}
								/>
								<BloxButton
									title='CROP'
									enabled={true}
									customClass='blox-button blox-button-swipe'
									onClick={this.closeModal}
									cypressId='crop-button'
								/>
							</div>
						</div>
					</Modal>
				)}
			</div>
		);
	}
}

export default ImageCrop;
